import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { TextAreaSimple } from '@resy/ui-kitchen';
import NPS from './NPS';
import FiveStarWrapper from './FiveStarWrapper';
import MultipleChoice from './MultipleChoice';
import Multiselect from './Multiselect';
import { sanitizeString } from '../../../../../ui-kitchen/src/utils/sanitizeString';

const Question = ({
  options,
  questionIndex,
  questionId,
  questionsetId,
  leftLabel,
  rightLabel,
  answerQuestion,
  characterMinimum,
  question,
  type,
}) => {
  const [comments, setComments] = useState('');
  const questionTypeMapper = (questionType) => {
    const sortedOptions = options.sort((a, b) => (a.order >= b.order ? 1 : -1));
    switch (questionType) {
      case 1:
        return (
          <NPS
            questionIndex={questionIndex}
            questionId={questionId}
            questionsetId={questionsetId}
            options={sortedOptions}
            leftLabel={leftLabel}
            rightLabel={rightLabel}
            answerQuestion={answerQuestion}
          />
        );
      case 2:
        return (
          <FiveStarWrapper
            questionIndex={questionIndex}
            questionId={questionId}
            questionsetId={questionsetId}
            options={sortedOptions}
            answerQuestion={answerQuestion}
          />
        );
      case 3:
        return (
          <MultipleChoice
            questionIndex={questionIndex}
            questionId={questionId}
            questionsetId={questionsetId}
            answerQuestion={answerQuestion}
            options={sortedOptions}
          />
        );
      case 4:
        return (
          <TextAreaSimple
            data-test-id="text-area"
            value={comments}
            placeholder={characterMinimum === null || characterMinimum === 0 ? 'Optional...' : ''}
            onChange={(e) => {
              setComments(e.target.value);
              answerQuestion(
                questionsetId,
                questionId,
                null,
                sanitizeString(e.target.value)
              );
            }}
          />
        );
      case 5:
        return (
          <Multiselect
            questionIndex={questionIndex}
            questionId={questionId}
            questionsetId={questionsetId}
            options={sortedOptions}
            answerQuestion={answerQuestion}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      <h2 className="RatingForm__label">
        {question}
        {type === 5 && ' Select all that apply:'}
      </h2>
      {questionTypeMapper(type)}
    </>
  );
};

Question.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      value: PropTypes.number,
      order: PropTypes.number,
    })
  ),
  questionIndex: PropTypes.number,
  questionId: PropTypes.number,
  questionsetId: PropTypes.number,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  answerQuestion: PropTypes.func,
  characterMinimum: PropTypes.number,
  question: PropTypes.string,
  type: PropTypes.number,
};

Question.defaultProps = {
  options: [],
  questionIndex: null,
  questionId: null,
  questionsetId: null,
  leftLabel: '',
  rightLabel: '',
  answerQuestion: () => { },
  characterMinimum: 0,
  question: '',
  type: null,
};

Question.displayName = 'Question';
export default Question;
